import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

export const AppErrorBoundary = () => {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} — ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'An unexpected error occurred.';
  return (
    <div className="flex min-h-screen items-center justify-center bg-navy p-8 text-white">
      <div className="max-w-md rounded bg-white/10 p-8 text-center">
        <h1 className="text-lg font-black uppercase tracking-widest text-teal">Something went wrong</h1>
        <p className="mt-3 text-sm text-white/80">{message}</p>
        <a href="/" className="mt-6 inline-block btn-teal">Back to home</a>
      </div>
    </div>
  );
};
